<template>
  <v-app>
    <TopNav v-if="showHeaderAndFooter" />
    <v-main>
      <router-view></router-view>
      <!-- <v-container>
      </v-container> -->

      <loading-dialog />
      <FooterSite v-if="showHeaderAndFooter" />
    </v-main>
    <v-snackbar
      v-model="$store.state.snackbar.show"
      :right="!$vuetify.breakpoint.mdAndDown"
      :bottom="$vuetify.breakpoint.smAndDown"
      :centered="$vuetify.breakpoint.smAndDown"
      :timeout="$store.state.snackbar.duration"
      :color="$store.state.snackbar.variant"
      rounded="lg"
      elevation="20"
    >
      {{ $store.state.snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="$store.dispatch('updateSnackbar', { show: false })"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>

    <confirm ref="confirm"></confirm>
  </v-app>
</template>

<script>
import TopNav from '@/components/TopNav'
import FooterSite from '@/components/FooterSite'
import Confirm from '@/components/base-dialog/Confirm'
import LoadingDialog from '@/components/loading-dialog/LoadingDialog'
import { mapState } from 'vuex'

export default {
  name: 'app',
  components: {
    TopNav,
    FooterSite,
    LoadingDialog,
    Confirm,
  },
  computed: {
    ...mapState('companyListModule', ['idCompanyList', 'companyList']),
    ...mapState('systemModule', ['system']),
    showHeaderAndFooter() {
      const context = this.$store.state.viewContext
      if (context == 'products') {
        return !!this.system
      } else if (context == 'companyList') {
        return (
          this.idCompanyList &&
          this.companyList &&
          this.companyList.CODIGO > 0 &&
          this.system
        )
      }
      return false
    },
  },
  mounted() {
    this.$root.$confirm = this.$refs.confirm.open
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;500;700&display=swap');
</style>
